<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-22 11:28:18
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-03-22 11:28:18
-->
<template>
<router-view></router-view>
</template>

<script>
export default {
name: "index"
}
</script>

<style scoped>

</style>
